import { WorkShift } from '@@partner:types:app'
import { GQL_ID } from '@@partner:types:graphql'
import { gql, useMutation } from '@apollo/client'

export interface WorkShiftInfoInput {
  id?: GQL_ID
  plannedStartAt: number
  plannedFinishAt: number
  assembler_id: GQL_ID
  status: number
  startedAt?: number | null
  finishedAt?: number | null
}

export interface UpdateWorkShift {
  updateWorkshift: WorkShift
}

export interface UpdateWorkShiftVariables {
  workShiftInfoInput: WorkShiftInfoInput
  createWorkShift: boolean
}

export interface DeleteWorkShiftVariables {
  workshift_id: GQL_ID
}

export const GQL_MUTATION_UPDATE_WORKSHIFT = gql`
  mutation($workShiftInfoInput: WorkShiftInfoInput, $createWorkShift: Boolean) {
    updateWorkshift(newData: $workShiftInfoInput, upsert: $createWorkShift) {
      id
      is_finished
      is_started
      status
      plannedStartAt
      plannedFinishAt
      assembler {
        id
      }
    }
  }
`

export const GQL_MUTATION_DELETE_WORKSHIFT = gql`
  mutation($workshift_id: ID!) {
    deleteWorkshift(id: $workshift_id)
  }
`
export const useMutateUpdateWorkshift = () => {
  return useMutation<UpdateWorkShift, UpdateWorkShiftVariables>(GQL_MUTATION_UPDATE_WORKSHIFT)
}


export const useMutateDeleteWorkShift = () => {
  return useMutation<DeleteWorkShiftVariables>(GQL_MUTATION_DELETE_WORKSHIFT)
}